import React from "react";
import StoreRegisterPage from "./store-register";
import UserRegisterPage from './user-register'
import UserStoreRegisterPage from "./user-store";
import StorelistPage  from './store-list'
import DrawerLayout from "../../components/DrawerLayout";
import UserListPage from "./user-list";
import ProtectedRoute from "../../hooks/ProtectedRoute";
const useRegisterRoutes = (props: any) => {
  const profile = localStorage.getItem('profile')
  const routers = React.useMemo(
    () => [
      profile === 'ADMIN' ?{
        path: "/store-register",
        element: (   <ProtectedRoute 
          outlet={
            <DrawerLayout colorMode={props}>
              <StoreRegisterPage />
            </DrawerLayout> } />
                

        ),
      }: null,
      profile === 'ADMIN' ? {
        path: "/store-edit/:id",
        element: (   <ProtectedRoute 
          outlet={
            <DrawerLayout colorMode={props}>
              <StoreRegisterPage />
            </DrawerLayout> } />
        ),
      }: null,  
      (profile === 'ADMIN' || profile === 'FR') ? {
        path: "/store-list",
        element: (   <ProtectedRoute 
          outlet={
          <DrawerLayout colorMode={props}>
                <StorelistPage />
                </DrawerLayout> } />
        ),
      }: null,
      profile === 'ADMIN' ? {
        path: "/user-store/:id",
        element: (   <ProtectedRoute 
          outlet={
          <DrawerLayout colorMode={props}>
                <UserStoreRegisterPage />
                </DrawerLayout> } />

        ),
      }: null,
      profile === 'ADMIN' ? {
        path: "/user-register",
        element: (   <ProtectedRoute 
          outlet={
          <DrawerLayout colorMode={props}>
                <UserRegisterPage />
          </DrawerLayout> } />
        ),
      }: null,
      profile === 'ADMIN' ? {
        path: "/user-edit/:publicId",
        element: (   <ProtectedRoute 
          outlet={
          <DrawerLayout colorMode={props}>
                <UserRegisterPage />
          </DrawerLayout> } />
        ),
      }: null,
      profile === 'ADMIN' ?  {
        path: "/user-list",
        element: (   <ProtectedRoute 
          outlet={
          <DrawerLayout colorMode={props}>
                <UserListPage />
                </DrawerLayout> } />
        ),
      }: null,
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return routers;
};

export default useRegisterRoutes;